<nb-layout>
  <nb-layout-header fixed class="nb-layout-header">
    <div class="top-line">&nbsp;</div>
        <div class="header-main">
          <div class="header__left">
            <a class="top-logo" [routerLink]="['/cabinet','sign-in']">
              <img alt="logo" class="logo" src="/assets/images/logo.svg">
            </a>
          </div>
        </div>
  </nb-layout-header>
  <nb-layout-column class="nb-layout-column">
    <div class="alert alert-danger" *ngIf="(state.get('tokenError') | async) === true" i18n="@@LinkNotValid">Ссылка не действительна</div>
    <div class="alert alert-danger" *ngIf="(state.get('resetError') | async) === true" i18n="@@ErrorOccurred">Произошла ошибка</div>
    <div class="alert alert-success" *ngIf="(state.get('resetSuccess') | async) === true" i18n="@@PasswordSuccessfullyChanged">
      Пароль успешно изменен - <a style="cursor:pointer; color:#039be5 !important; position: absolute; z-index:100;" [routerLink]="['/cabinet','sign-in']">войти в систему</a>.
    </div>

    <div class="reset-content">
      <div class="block">
        <ng-container *ngIf="(state.get('showForm') | async) === true">
        <div class="text">
          <h1>Новый пароль</h1>
          <p>Придумайте надежный пароль для вашего аккаунта</p>
        </div>
        <form [formGroup]="resetForm" novalidate (ngSubmit)="onSubmit()">
            <div class="control-group">
              <div>
                <div><label for="exampleInputPassword1">Новый пароль</label></div>
                <input formControlName="password"
                       [ngClass]="{'input-invalid': !(isValidPassFields | async)}"
                       nbInput
                       fullWidth
                       id="exampleInputPassword1"
                       type="password"
                       placeholder="Введите новый пароль"
                       required>
              </div>
              <div class="invalid-feedback"
                   *ngIf="resetForm.controls.password.errors?.minlength && resetForm.controls.password.touched" i18n>
                пароль слишком короткий
              </div>
              <div class="invalid-feedback"
                   *ngIf="resetForm.controls.password.errors?.required && resetForm.controls.password.touched" i18n>
                укажите пароль
              </div>
            </div>

            <div class="control-group">
              <div>
                <div><label for="exampleInputPassword2">Повторите пароль</label></div>
                <input formControlName="repeatPassword" (focus)="resetForm.controls.repeatPassword.markAsTouched()"
                       [ngClass]="{'input-invalid':!(isValidPassFields | async)}"
                       nbInput id="exampleInputPassword2"
                       fullWidth
                       type="password"
                       placeholder="Повторите новый пароль" requir
                       ed>
              </div>

              <div class="invalid-feedback" *ngIf="!(isValidPassFields | async) && resetForm.touched" i18n>пароли не совпадают</div>
            </div>
            <button nbButton status="primary" fullWidth size="large" [disabled]="!(isValidForm | async)" type="submit">
              Сохранить пароль
            </button>
        </form>
        </ng-container>
      </div>
    </div>
  </nb-layout-column>
  <nb-layout-footer class="nb-layout-footer">
    <div class='footer'>
      <img alt="logo" class="logo" src="/assets/images/logo.svg">
    </div>
  </nb-layout-footer>
</nb-layout>
